import script from "./UnpublishButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnpublishButton.vue?vue&type=script&lang=ts&setup=true"

import "./UnpublishButton.vue?vue&type=style&index=0&id=35f32952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f32952"]])

export default __exports__